import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {ControlAreaService} from 'app/blocks/service/api/control-area.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IControlArea, ControlArea} from 'app/blocks/model/control-area.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ControlAreaResource extends AbstractEntityResource<IControlArea> {
    constructor(controlAreaService: ControlAreaService, router: Router) {
        super(
            Resource.CONTROL_AREAS,
            controlAreaService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CONTROL_AREAS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CONTROL_AREAS),
            (entity?) => new ControlArea(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
